export const LOGIN_ROUTE_PATH = '/login';
export const FORGOT_PASSWORD_ROUTE_PATH = '/forgot_password';
export const VERIFY_CODE_ROUTE_PATH = '/verify_code/:username';
export const UPDATE_PASSWORD_ROUTE_PATH = '/update_password/:code';
export const SIGNUP_ROUTE_PATH = '/signup';
export const SIGNUP_OWNER_ROUTE_PATH = '/signup/owner';
export const SIGNUP_MANAGER_ROUTE_PATH = '/signup/manager';
